import {UIHomepageAdView} from './UIHomepageAdView'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {TimeoutId} from '@colonist/types'

export abstract class UIHomepageStoreAdController {
    protected view: UIHomepageAdView
    private timer: TimeoutId
    private readonly UPDATE_AD_DURATION = 1000 * 60
    private wasLoggedIn: boolean | undefined = undefined

    constructor() {
        this.createAdView()

        ClientUserState.registerChangeListener((userState) => {
            if(userState == undefined) return
            if(this.wasLoggedIn === userState.isLoggedIn) return

            this.start()

            this.wasLoggedIn = userState.isLoggedIn
        })
    }

    protected abstract createAdView()

    private stop() {
        if(this.timer == undefined) return
        clearTimeout(this.timer)
    }

    private start() {
        this.stop()
        this.view.update()
        this.timer = setInterval(() => {
            this.view.update()
        }, this.UPDATE_AD_DURATION)
    }
}
